import { apiClient } from './apiClient';

export interface ActivityEntry {
  id: number;
  project_id: number;
  actor_id: number | null;
  actor_name: string | null;
  action: string;
  description: string;
  created_at: string;
}

const activityService = {
  listActivity: async (projectId: number): Promise<ActivityEntry[]> => {
    const response = await apiClient.get<ActivityEntry[]>(`fdc/tasks/by-project/${projectId}/activity`);
    return response.data;
  },
};

export default activityService;
